export default __webpack_public_path__ + "static/852-24e9cc15d2288ad35990f7ae2da8447d.gif";